import { render } from "./optionsMenu.vue?vue&type=template&id=44c0dca2&bindings={\"optionsMenuIsOpen\":\"props\",\"newOptions\":\"data\",\"updateOptionsAndClose\":\"options\",\"refresh\":\"options\"}"
import script from "./optionsMenu.vue?vue&type=script&lang=js"
export * from "./optionsMenu.vue?vue&type=script&lang=js"

import "./optionsMenu.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script